export default () => ({
  total: null,
  open: false,
  slide: 1,
  maxSlides: null,
  isZoomed: false,
  touchStartX: 0,
  touchStartY: 0,

  init() {
    this.$watch("open", (value) => {
      if (!value) {
        // Ensure scrolling is restored when modal closes
        Grebify.noScroll(false);
        this.isZoomed = false;
      }
    });

    // Add touch gesture support for mobile
    this.$nextTick(() => {
      const container = this.$refs.container;
      if (container) {
        container.addEventListener(
          "touchstart",
          this.handleTouchStart.bind(this),
          { passive: true }
        );
        container.addEventListener("touchend", this.handleTouchEnd.bind(this), {
          passive: true,
        });
      }
    });
  },

  handleTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
  },

  handleTouchEnd(event) {
    if (!this.touchStartX || !this.touchStartY) return;

    const touchEndX = event.changedTouches[0].clientX;
    const touchEndY = event.changedTouches[0].clientY;

    const deltaX = this.touchStartX - touchEndX;
    const deltaY = this.touchStartY - touchEndY;

    // Only handle horizontal swipes (ignore vertical swipes)
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
      if (deltaX > 0) {
        // Swipe left - next slide
        this.switchSlide(1);
      } else {
        // Swipe right - previous slide
        this.switchSlide(-1);
      }
    }

    // Reset touch coordinates
    this.touchStartX = 0;
    this.touchStartY = 0;
  },

  // Ensure slide is always valid when modal opens
  openModal() {
    this.open = true;
    Grebify.noScroll(true);

    // Ensure slide is within bounds
    if (this.slide > this.maxSlides) {
      this.slide = this.maxSlides;
    } else if (this.slide < 1) {
      this.slide = 1;
    }
  },

  toggle() {
    if (this.open) {
      this.closeModal();
    } else {
      this.openModal();
    }
  },

  closeModal() {
    this.open = false;
    this.isZoomed = false;
    Grebify.noScroll(false);
  },

  toggleZoom() {
    // Only allow zoom on desktop/tablet (768px and wider)
    if (window.innerWidth >= 768) {
      this.isZoomed = !this.isZoomed;
    }
  },

  setSlide(index) {
    if (index && typeof index === "number") {
      this.isZoomed = false;
      this.slide = index;

      // Ensure the slide index is within bounds
      if (this.slide > this.maxSlides) {
        this.slide = this.maxSlides;
      } else if (this.slide < 1) {
        this.slide = 1;
      }

      // Update active slide highlighting
      this.$nextTick(() => {
        const images = this.$refs.container.querySelectorAll(".slide");

        images.forEach((image) => {
          image.classList.remove("active_image");
        });

        if (images[this.slide - 1]) {
          images[this.slide - 1].classList.add("active_image");
        }
      });
    }
  },

  switchSlide(newSlide) {
    this.isZoomed = false;
    this.slide += newSlide;

    if (this.slide > this.maxSlides) {
      this.slide = 1;
    } else if (this.slide < 1) {
      this.slide = this.maxSlides;
    }

    // Update active slide highlighting
    this.$nextTick(() => {
      const images = this.$refs.container.querySelectorAll(".slide");

      images.forEach((image) => {
        image.classList.remove("active_image");
      });

      if (images[this.slide - 1]) {
        images[this.slide - 1].classList.add("active_image");
      }
    });
  },
});
